import { useState, useCallback } from 'react';
import { TourTooltip } from './TourTooltip';

const TOUR_STEPS = [
  {
    targetId: 'nav-map',
    title: '📍 Me localiser',
    message: 'Clique ici pour te localiser et voir les lieux près de chez toi !',
  },
  {
    targetId: 'nav-search',
    title: '🔍 Rechercher',
    message: 'Recherche un lieu par nom, catégorie ou adresse.',
  },
  {
    targetId: 'nav-favorites',
    title: '❤️ Favoris',
    message: 'Sauvegarde tes lieux préférés pour les retrouver facilement.',
  },
  {
    targetId: 'nav-add',
    title: '➕ Ajouter un lieu',
    message: 'Ajoute un nouveau lieu et gagne 200 points !',
  },
  {
    targetId: 'nav-profile',
    title: '👤 Mon profil',
    message: 'Consulte tes badges, points et échange-les contre des réductions !',
  },
];

interface OnboardingTourProps {
  open: boolean;
  onComplete: (completed: boolean) => void;
}

export const OnboardingTour = ({ open, onComplete }: OnboardingTourProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleNext = useCallback(() => {
    if (currentStep < TOUR_STEPS.length - 1) {
      setCurrentStep(prev => prev + 1);
    } else {
      // Tour completed
      onComplete(true);
    }
  }, [currentStep, onComplete]);

  const handleSkip = useCallback(() => {
    onComplete(false);
  }, [onComplete]);

  if (!open) return null;

  const step = TOUR_STEPS[currentStep];

  return (
    <TourTooltip
      targetId={step.targetId}
      title={step.title}
      message={step.message}
      step={currentStep}
      totalSteps={TOUR_STEPS.length}
      onNext={handleNext}
      onSkip={handleSkip}
      isLastStep={currentStep === TOUR_STEPS.length - 1}
    />
  );
};
